export default "__VITE_ASSET__1pUNw$RN__ 1200w";